import { AxiosRequestConfig } from "axios";
import { sendGet, sendPost, sendPut, sendPatch, sendPostWithoutSignOut, signOutAxios } from "../baseUtils";
import { buildUtmPayload } from "utils/utmPayload";

export const changePassword = (credentials: unknown) => sendPatch("/", credentials);

export const getUserVerifyData = () =>
  sendGet("/verify").then(res => {
    return res.data;
  });

export const getIntercomToken = () => sendGet("/intercom_token").then(res => res.data);

export const registerAliexpressToken = async ({ aliexpressToken }: { aliexpressToken: string }) =>
  sendPost("/aliexpress/load", { aliexpress_token: aliexpressToken });

interface OnboardingFlowOptions {
  selectedCategories: unknown;
  selectedProductsKind: unknown;
  selectedRegion: unknown;
  createStoreOption: unknown;
  selectedColorScheme: unknown;
  selectedPersonality: unknown;
}

export const sendOnboardingFlowOptions = async ({
  selectedCategories: categories,
  selectedProductsKind: kind,
  selectedRegion: sales_region,
  createStoreOption: create_store_on_provider,
  selectedColorScheme: color_scheme,
  selectedPersonality: personality
}: OnboardingFlowOptions) =>
  sendPut("/stores/preference", {
    categories,
    color_scheme,
    kind,
    sales_region,
    create_store_on_provider,
    personality
  });

export const resetPassword = async (
  { email, hCaptchaToken }: { email: string; hCaptchaToken?: string },
  config?: AxiosRequestConfig
) =>
  sendGet(
    "/password/new",
    {
      email,
      "h-captcha-response": hCaptchaToken
    },
    false,
    config
  );

export const verifyPassword = async ({ password }: { password: string }) =>
  sendPost("/password/verify", {
    password
  });

export const signInUser = async (
  {
    email,
    password,
    hCaptchaToken,
    authToken
  }: { email: string; password: string; hCaptchaToken?: string; authToken?: string },
  config?: AxiosRequestConfig
) => {
  signOutAxios();
  localStorage.removeItem("auth_token");
  return sendPostWithoutSignOut(
    "/sign_in",
    {
      email,
      password,
      "h-captcha-response": hCaptchaToken,
      auth_token: authToken
    },
    config
  ).then(res => {
    return res.data;
  });
};

export const signUp = async (
  { userName, email, hCaptchaToken }: { userName: string; email: string; hCaptchaToken?: string },
  config?: AxiosRequestConfig
) =>
  sendPostWithoutSignOut(
    "/sign_up",
    {
      email,
      name: userName,
      "h-captcha-response": hCaptchaToken,
      stores_attributes: [
        {
          name: null
        }
      ],
      // Lets the API put the attribution on the Stripe customer it creates at signup
      utm: buildUtmPayload()
    },
    config
  );

export const changeName = async ({ name }: { name: string }) => sendPut("/data/dropshipper", { name });

export const changeEmail = async ({ email }: { email: string }) => sendPost("/mail_verification", { email });

export const changeEmailConfirm = async ({
  email,
  verificationCode
}: {
  email: string;
  verificationCode: string;
}) =>
  sendPost("/mail_verification/confirm", {
    email,
    verification_code: verificationCode
  });
